import { AttachmentBadgeUtil } from '../AttachmentBadge/attachment-badge-util';

/*
  Narrower than the `image` kind: HEIC, HEIF and TIFF are pictures Chrome and Firefox cannot decode,
  so asking for one spends a request to arrive at the badge it was always going to show.
*/
const DISPLAYABLE = new Set(['GIF', 'JPEG', 'JPG', 'PNG', 'WEBP']);

/**
 * AttachmentPreviewUtil - I say whether a file can be drawn at all, so a caller knows before it
 * fetches. ONLY concerned with that question - no fetching, no caching, no rendering.
 *
 * **This gates the request, not the outcome.** Whether the bytes actually render is still the
 * browser's to decide and the preview's `onError` to report: a file named `.png` that is not one
 * reaches the `<img>` and only the `<img>` finds out.
 */
export const AttachmentPreviewUtil = {
  isDisplayableImage({ fileName }: { fileName: string }) {
    return DISPLAYABLE.has(AttachmentBadgeUtil.extensionOf({ fileName }));
  },
};
